import { render, staticRenderFns } from "./QuoteEmail.vue?vue&type=template&id=27816e88&scoped=true"
import script from "./QuoteEmail.vue?vue&type=script&lang=js"
export * from "./QuoteEmail.vue?vue&type=script&lang=js"
import style0 from "./QuoteEmail.vue?vue&type=style&index=0&id=27816e88&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27816e88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27816e88')) {
      api.createRecord('27816e88', component.options)
    } else {
      api.reload('27816e88', component.options)
    }
    module.hot.accept("./QuoteEmail.vue?vue&type=template&id=27816e88&scoped=true", function () {
      api.rerender('27816e88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/QuoteEmail.vue"
export default component.exports